import { c as _c } from "react/compiler-runtime";
import type { ReactNode, MouseEvent } from 'react';
import Hyperlink from '@classify/react-core-components/Hyperlink';
import { getButtonLinkProps } from '@openclassrooms/routing';
import FooterItem from './FooterItem';
interface Props {
  children: ReactNode;
  path?: string;
  rawPath?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  isSmall?: boolean;
}
export default function FooterLinkItem(t0) {
  const $ = _c(12);
  const {
    children,
    path,
    rawPath,
    onClick,
    isSmall
  } = t0;
  const target = path?.startsWith("http") ? "_blank" : undefined;
  let t1;
  if ($[0] !== path || $[1] !== rawPath) {
    t1 = path ? getButtonLinkProps(path) : {
      href: rawPath ?? "#"
    };
    $[0] = path;
    $[1] = rawPath;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const linkProps = t1;
  const t2 = isSmall ? "0.8rem" : undefined;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      textDecoration: "none"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = {
      whiteSpace: "inherit",
      fontSize: t2,
      fontWeight: "normal",
      "&:hover": t3
    };
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== linkProps || $[8] !== onClick || $[9] !== t4 || $[10] !== target) {
    t5 = <FooterItem component="li"><Hyperlink {...linkProps} target={target} onClick={onClick} underline="none" variant="small" color="secondary" sx={t4}>{children}</Hyperlink></FooterItem>;
    $[6] = children;
    $[7] = linkProps;
    $[8] = onClick;
    $[9] = t4;
    $[10] = target;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}